import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiurl } from "../Constants";

export const fetchQuickLinks = createAsyncThunk(
  "quicklinks/fetchquicklinks",
  async () => {
    const response = await axios.get(apiurl + "quicklink");
    return response.data.data;
  }
);

const initialState = {
  quicklink: [],
  status: "idle",
  error: null,
  loading: false,
};

const quicklinkSlice = createSlice({
  name: "quicklinks",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuickLinks.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(fetchQuickLinks.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeded";
        state.quicklink = action.payload;
      })
      .addCase(fetchQuickLinks.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default quicklinkSlice.reducer;
